import de from './de-DE.json'
import en from './en-US.json'
import es from './es-ES.json'
import fr from './fr-FR.json'
import it from './it-IT.json'
import pl from './pl-PL.json'
import pt from './pt-PT.json'
import ru from './ru-RU.json'
import tr from './tr-TR.json'

const resources = {
  'de-DE': de,
  'en-US': en,
  'es-ES': es,
  'fr-FR': fr,
  'it-IT': it,
  'pl-PL': pl,
  'pt-PT': pt,
  'ru-RU': ru,
  'tr-TR': tr
}

export default resources
